import { toMillis } from './timestamps';

// Returns "Today", "Yesterday", or a formatted date string like "Mon Apr 5"
// for use as a date group divider label.
export function getDateLabel(timestamp) {
  const ms = toMillis(timestamp);
  if (!ms) return '';

  const date = new Date(ms);
  const now = new Date();

  const todayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const yesterdayStart = new Date(todayStart);
  yesterdayStart.setDate(yesterdayStart.getDate() - 1);

  if (ms >= todayStart.getTime()) return 'Today';
  if (ms >= yesterdayStart.getTime()) return 'Yesterday';

  return date.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
}

// Returns the date key (YYYY-MM-DD) for grouping comparison.
export function getDateKey(timestamp) {
  const ms = toMillis(timestamp);
  if (!ms) return '';
  const d = new Date(ms);
  return `${d.getFullYear()}-${d.getMonth()}-${d.getDate()}`;
}
